<template>
  <div
    class="recipe-card-wrapper"
  >
    <recipe-card
      :button-size="buttonSize"
      :block-size="blockSize"
      :recipe="recipe"
      :is-saved="isSavedInner"
      @is-saved="toggleSaveRecipe"
      @is-clicked="trackClick"
      @open-folder-modal="openFolderModal"
    />
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { service } from '@/services/'
  import dataLayer from '@/analytics/dataLayer'
  import RecipeCard from '../molecules/RecipeCard.vue'

  export default {
    name: "RecipeCardWrapper",
    components: {
      RecipeCard
    },
    props: {
      blockSize: {
        type: String,
        default: "quarter",
        validator (value) {
          return ["full", "half", "third", "quarter"].includes(value)
        }
      },
      recipe: {
        type: Object,
        default: null
      },
      buttonSize: {
        type: Number,
        default: 40
      },
      tracking: {
        type: Object,
        default: function () {
          return {}
        }
      },
    },
    data () {
      return {
        isSavedInner: this.recipe.userInteraction && this.recipe.userInteraction.recipeSaved, // On create isSaved gets its value from the prop (recipyBlock for example)
        saveRecipe: false
      }
    },
    methods: {
      ...mapActions(['getPublicAccessToken']),
      openFolderModal (data) {
        this.$emit('open-folder-modal', data)
      },
      forceLogin () {
        this.$ICALogin.forceUserLogin(this.$root.envConfig.loginEndpointUrl)
      },
      trackClick () {
        dataLayer.add({
          event: 'recipeSelect',
          recipeId: String(this.recipe.id),
          recipeName: this.recipe.title,
          linkName: this.recipe.title,
          linkUrl: !/^https?:\/\//i.test(this.recipe.url) ? window.location.origin + this.recipe.url : this.recipe.url,
          ...this.tracking
        })
      },
      async toggleSaveRecipe (isSaved) {
        if (!this.$root.isLoggedIn) {
          this.forceLogin()
          return
        }

        this.isSavedInner = !this.isSavedInner

        const serviceResponse = await service.toggleSaveRecipe({
          url: this.$root.envConfig.recipeExperienceApiBaseUrl,
          isSaved: isSaved,
          recipeId: this.recipe.id,
          publicAccessToken: await this.getPublicAccessToken()
        })

        dataLayer.add({
          event: isSaved ? 'recipeSave' : 'recipeUnsave',
          recipeId: String(this.recipe.id),
          recipeName: this.recipe.title,
          recipeUrl: this.recipe.url,
          succeeded: serviceResponse.success ? '1' : '0',
          ...this.tracking
        })

        // Revert change if unsuccesful
        if(!serviceResponse.success) {
          this.isSavedInner = !this.isSavedInner
        }
      }
    }
  }
</script>

<style lang="scss">
  .save-recipe-button-wrapper {
    position: absolute;
    top: 0;
    width: 100%;

    .save-recipe-button {
      position: absolute;
      right: 0.5rem;
      top: 0.5rem;
      z-index: 1;
    }
  }
</style>
